import React from 'react';
import PropTypes from 'prop-types';
import cssModule from 'react-css-modules';
import { connect } from 'react-redux';

import DisplaySolutionIcon from 'newDesign/modules/announcement/components/displaySolutionIcon/DisplaySolutionIcon';
import {
  getTournamentName,
} from 'reducers';

import style from 'newDesign/modules/announcement/components/tournamentInfo/TournamentInfo.scss';


const mapStateToProps = (state, ownProps) => ({
  tournamentName: getTournamentName(state, ownProps.matchId),
});

const TournamentInfo = ({
  matchId,
  tournamentName,
}) => (
  <div
    styleName='conditionalAlignment'
    className={'flex flex-1 justify-end'}
  >
    <DisplaySolutionIcon matchId={matchId} />
    <div className='font-second ml-4 py-2 fs-17'>
      <span>
        {tournamentName}
      </span>
    </div>
  </div>
);

TournamentInfo.propTypes = {
  matchId: PropTypes.number.isRequired,
  tournamentName: PropTypes.string,
};

TournamentInfo.defaultProps = {
  tournamentName: null,
};

const TournamentInfoStyled = cssModule(TournamentInfo, style);
export default connect(mapStateToProps)(TournamentInfoStyled);
